import React from 'react';
import { AccordionBodyItemView } from 'component/Accordion';
import { removeLeadingZeros } from '../../../../utils/Helper';

export const NaturalResoursesView = (props) => {
  const { formData } = props;
  const landuse = formData.info.landuse_and_beneficiaries;

  return (
    <AccordionBodyItemView
      accordionSubId="8.6"
      titleUA="Природні ресурси"
      titleEN="Natural resourses"
      children={(
        <div className="flex-group flex-wrap">
          {removeLeadingZeros(landuse.natural_resources)}
        </div>
      )}
    />
  );
};
